import { render, staticRenderFns } from "./LayerWidgetPanel.vue?vue&type=template&id=122c8e4e&scoped=true"
import script from "./LayerWidgetPanel.vue?vue&type=script&lang=js"
export * from "./LayerWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./LayerWidgetPanel.vue?vue&type=style&index=0&id=122c8e4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c8e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122c8e4e')) {
      api.createRecord('122c8e4e', component.options)
    } else {
      api.reload('122c8e4e', component.options)
    }
    module.hot.accept("./LayerWidgetPanel.vue?vue&type=template&id=122c8e4e&scoped=true", function () {
      api.rerender('122c8e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/LayerWidgetPanel.vue"
export default component.exports